import { ReactNode } from 'react';

// TODO (KC-427: Added the h-full workaround caused by this KC change. Long-term solution TBC by KC team)
export const CardHeightWrapper = ({ children }: { children: ReactNode }) => (
  <div className="h-full [&>div]:h-full [&>div>div]:h-full [&>div>div]:justify-center">{children}</div>
);
